var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "60px" } },
    [
      _c("template", { slot: "header" }, [_vm._v("Cambio de matrícula")]),
      _vm._v(" "),
      _c("div", { staticClass: "alert-type" }, [
        _c("h4", { staticClass: "is-uppercase" }, [
          _vm._v("Nuevo Estado de Matrícula")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedStateId,
                  expression: "selectedStateId"
                }
              ],
              attrs: { required: "" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedStateId = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c(
                "option",
                { attrs: { value: "-1", selected: "", disabled: "" } },
                [_vm._v("Seleccionar estado")]
              ),
              _vm._v(" "),
              _vm._l(_vm.availableStudentStates, function(s) {
                return _c("option", { key: s.id, domProps: { value: s.id } }, [
                  _vm._v(_vm._s(s.code))
                ])
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alert-details" }, [
        _c("h4", { staticClass: "is-uppercase" }, [_vm._v("CAUSA")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.details,
              expression: "details"
            }
          ],
          attrs: { placeholder: "Por favor especificar la causa del cambio" },
          domProps: { value: _vm.details },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.details = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("derivation-list", {
        attrs: { derivations: _vm.derivations },
        on: {
          "update:derivations": function($event) {
            _vm.derivations = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary add",
            class: { "is-loading": _vm.loading },
            attrs: { disabled: !_vm.isValid },
            on: { click: _vm.submit }
          },
          [_vm._v("\n      Agregar\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-primary is-outlined cancel",
            attrs: { disabled: _vm.loading },
            on: { click: _vm.cancel }
          },
          [_vm._v("\n      Cancelar\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }